"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var CameraIcon = function CameraIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#333F48' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 20 : _ref$size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M9.99984 6.66675C8.19317 6.66675 6.6665 8.19341 6.6665 10.0001C6.6665 11.8067 8.19317 13.3334 9.99984 13.3334C11.8065 13.3334 13.3332 11.8067 13.3332 10.0001C13.3332 8.19341 11.8065 6.66675 9.99984 6.66675ZM9.99984 11.6667C9.11234 11.6667 8.33317 10.8876 8.33317 10.0001C8.33317 9.11258 9.11234 8.33341 9.99984 8.33341C10.8873 8.33341 11.6665 9.11258 11.6665 10.0001C11.6665 10.8876 10.8873 11.6667 9.99984 11.6667Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M16.6665 4.16675H14.5115L12.2557 1.91091C12.0998 1.75425 11.8882 1.66675 11.6665 1.66675H8.33317C8.1115 1.66675 7.89984 1.75425 7.744 1.91091L5.48817 4.16675H3.33317C2.414 4.16675 1.6665 4.91425 1.6665 5.83341V15.0001C1.6665 15.9192 2.414 16.6667 3.33317 16.6667H16.6665C17.5857 16.6667 18.3332 15.9192 18.3332 15.0001V5.83341C18.3332 4.91425 17.5857 4.16675 16.6665 4.16675ZM3.33317 15.0001V5.83341H5.83317C6.05484 5.83341 6.2665 5.74591 6.42234 5.58925L8.67817 3.33341H11.3215L13.5773 5.58925C13.7332 5.74591 13.9448 5.83341 14.1665 5.83341H16.6665L16.6682 15.0001H3.33317Z",
    fill: color
  }));
};

var _default = CameraIcon;
exports.default = _default;